var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 25,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5625 8.5C9.63357 8.5 11.3125 6.82107 11.3125 4.75C11.3125 2.67893 9.63357 1 7.5625 1C5.49143 1 3.8125 2.67893 3.8125 4.75C3.8125 6.82107 5.49143 8.5 7.5625 8.5Z",
    stroke: "#50618B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7519 16C12.9613 16.0002 13.1679 15.947 13.356 15.8446C13.5441 15.7421 13.7086 15.5931 13.837 15.4089C13.9654 15.2248 14.0541 15.0103 14.0966 14.7821C14.139 14.5538 14.1339 14.3178 14.0817 14.092C13.7022 12.4894 12.8569 11.0718 11.6776 10.0602C10.4983 9.04859 9.05131 8.5 7.5625 8.5C6.07369 8.5 4.62675 9.04859 3.44744 10.0602C2.26813 11.0718 1.42278 12.4894 1.0433 14.092C0.991108 14.3178 0.986028 14.5538 1.02844 14.7821C1.07086 15.0103 1.15965 15.2248 1.28801 15.4089C1.41636 15.5931 1.58089 15.7421 1.76897 15.8446C1.95705 15.947 2.16371 16.0002 2.3731 16H12.7519Z",
    stroke: "#50618B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersIcon);
export default __webpack_public_path__ + "static/media/Users_Icon.cb3a186ed4d8738524e949f886efb1bb.svg";
export { ForwardRef as ReactComponent };